import { Authorization } from '@/types';

/**
 * Top-nav Settings and the user-menu Settings item.
 * Same rule as SettingsRoute: global Admin, or the global settings.manage action.
 */
export function canManageBusinessUnitSettings(
  authorization: Authorization | null | undefined,
): boolean {
  return Boolean(
    authorization?.globalAdmin || authorization?.actions.includes('settings.manage'),
  );
}
